import { render, staticRenderFns } from "./memmber_transDeta.vue?vue&type=template&id=364e854b&scoped=true&"
import script from "./memmber_transDeta.vue?vue&type=script&lang=js&"
export * from "./memmber_transDeta.vue?vue&type=script&lang=js&"
import style0 from "./memmber_transDeta.vue?vue&type=style&index=0&id=364e854b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "364e854b",
  null
  
)

export default component.exports